<app-layout>
  <app-voltar route="listagem/laudos-higienizacao" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form" (ngModelChange)="clearForms()">
      <div class="formList">
        <div class="grid-double-input">
          <app-input
            type="disabled"
            label="Placa do Cavalo"
            name="TX_PLCA_CAVA"
            formControlName="TX_PLCA_CAVA"
            placeholder="Digite aqui"
            mask="AAA-0000||AAA-0A00"></app-input>
          <app-input
            type="disabled"
            label="Quilometragem"
            name="QT_KM"
            formControlName="QT_KM"
            placeholder="Digite aqui"></app-input>
        </div>
        <app-input
          type="disabled"
          label="N° do Agendamento"
          name="PK_AGND"
          formControlName="PK_AGND"
          placeholder="Digite o número do agendamento"
          mask="0000000000"></app-input>
        <app-input
          type="disabled"
          label="FIHL / Lava Jato N°"
          name="FK_SRVC_ENTR"
          formControlName="FK_SRVC_ENTR"
          placeholder="Digite o número do ticket de serviço de Higienização"></app-input>
        <app-input
          type="disabled"
          label="Transportadora"
          name="NM_TRND"
          formControlName="NM_TRND"
          placeholder="Digite aqui"></app-input>
        <app-input
          type="disabled"
          label="CPF/CNPJ"
          mask="000.000.000-00||00.000.000/0000-00"
          name="TX_CPF_CNPJ_TRND"
          formControlName="TX_CPF_CNPJ_TRND"
          placeholder="Digite aqui"></app-input>
        <app-input
          type="disabled"
          label="Data e Horário do Serviço"
          name="DT_SRVC_ENTR"
          formControlName="DT_SRVC_ENTR"
          placeholder="Digite aqui"></app-input>
        <app-input
          type="disabled"
          label="Telefone da Transportadora"
          mask="(00) 00000-00000"
          name="NU_TELE_TRND"
          formControlName="NU_TELE_TRND"
          placeholder="Digite aqui"></app-input>
        <app-input
          type="disabled"
          label="Motorista"
          name="NM_MTTR"
          formControlName="NM_MTTR"
          placeholder="Digite aqui"></app-input>
        <app-input
          type="disabled"
          label="RG"
          name="TX_RG"
          formControlName="TX_RG"
          placeholder="Digite aqui"
          maxLength="9"></app-input>
        <app-input
          type="disabled"
          label="CPF"
          name="TX_CPF"
          formControlName="TX_CPF"
          placeholder="Digite aqui"
          mask="000.000.000-00"></app-input>
        <app-input
          type="disabled"
          label="Reboque-1 (Carreta 1)"
          name="TX_CRRT_1"
          formControlName="TX_CRRT_1"
          placeholder="Digite aqui"
          mask="AAA-0000||AAA-0A00"></app-input>
        <app-input
          type="disabled"
          label="Reboque-2 (Carreta 2)"
          name="TX_CRRT_2"
          formControlName="TX_CRRT_2"
          placeholder="Digite aqui"
          mask="AAA-0000||AAA-0A00"></app-input>
        <app-input
          type="disabled"
          label="Reboque-3 (Carreta 3)"
          name="TX_CRRT_3"
          formControlName="TX_CRRT_3"
          placeholder="Digite aqui"
          mask="AAA-0000||AAA-0A00"></app-input>
        <app-input
          type="disabled"
          label="Tipo da Carreta"
          name="TX_TIPO_CRRT"
          formControlName="TX_TIPO_CRRT"
          placeholder="Digite aqui"></app-input>
        <app-input
          type="disabled"
          label="Tipo de Carga (Resíduo)"
          name="TX_TIPO_CRGA"
          formControlName="TX_TIPO_CRGA"
          placeholder="Digite aqui"></app-input>
        <app-input
          type="disabled"
          label="Operador:"
          name="NM_OPER"
          formControlName="NM_OPER"
          placeholder="Digite aqui"
          [disabled]="this.statusInput"></app-input>
        <app-input
          type="disabled"
          label="Observação:"
          name="TX_OBSV"
          formControlName="TX_OBSV"
          placeholder="Digite aqui"
          [disabled]="true"></app-input>
      </div>
    </form>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
